import React, { useState } from 'react'



const Giftcard = () => {
    const [show_more, setShow_more] = useState(false)
    
    function showMore() {
        setShow_more((current => !current))
    }
   
    return (
        <main>

            <p className='profile-title'>  Gavekort </p>
            <div className='giftcards'>
                <div style={{ margin: 0,padding:0 } }>
                    <p className='amount'>200 kr.</p>
                    <span className='date'>udløber d. 15/09/26</span>
                </div>
                <button className='show-more' onClick={showMore }>Vis mere</button>
                <div>
                    <p className='valid'>Gælder til:</p>
                    <p className='org-name'>Scala Svendborg</p>
                </div>
            </div>
            {show_more === true ?
                <div className='giftcards'>
                    <div>
                        <p className='valid'>Indhold:</p>
                        <p>1 biografbillet (op til 100 kr.)</p>
                        <div style={{ position: 'relative' }}>
                            <p style={{ position: 'absolute' ,top:'-15px'}} className='ticket'>Biografbillet</p>
                            <svg width="114" height="40" viewBox="0 0 114 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path d="M114 1H113V3H114V5H113V7H114V9H113V11H114V13C110.134 13.0001 107 16.1341 107 20C107 23.8659 110.134 26.9999 114 27V29H113V31H114V33H113V35H114V37H113V39H114V40H0V39H1V37H0V35H1V33H0V31H1V29H0V27C3.86599 27 7 23.866 7 20C7 16.134 3.86599 13 0 13V11H1V9H0V7H1V5H0V3H1V1H0V0H114V1Z" fill="url(#paint0_linear_1193_1157)" />
                                <defs>
                                    <linearGradient id="paint0_linear_1193_1157" x1="41" y1="-2.49998" x2="79.5" y2="38.5" gradientUnits="userSpaceOnUse">
                                        <stop offset="0.153846" stop-color="#F1AA51" />
                                        <stop offset="0.399038" stop-color="#DB953E" />
                                        <stop offset="0.699519" stop-color="#FABD71" />
                                        <stop offset="1" stop-color="#CE8121" />
                                    </linearGradient>
                                </defs>
                            </svg>

                        </div>
                    </div>
                    <button className='show-more'>Vis mindre</button>
                    <div>
                        <p className='valid'>Adresse:</p>
                        <p className='org-name'>Scala Svendborg</p>
                    </div>
                </div>
                : null}
        </main>
    )
}

export default Giftcard